import React, { useState } from "react";
import { useAppBrandInfo, DEFAULT_BRAND_INFO } from "../hooks/useAppBrandInfo";

export default function BrandLogo(props) {
  const { brandInfo } = useAppBrandInfo();
  const [failedUrl, setFailedUrl] = useState(null);
  return <img {...props}
    src={failedUrl === brandInfo.app_logo_url ? DEFAULT_BRAND_INFO.app_logo_url : brandInfo.app_logo_url}
    alt={`${brandInfo.app_name} logo`}
    onError={() => setFailedUrl(brandInfo.app_logo_url)}
  />;
}
